import React, { useRef, useState, useEffect } from 'react';
import Hero from './Hero';
import ContactFormSection from './ContactFormSection';
import FaqSection from './FaqSection';
import Navbar from '../Navbar';
import Footer from '../Footer';

const ContactPage = () => {
  const refs = {
    hero: useRef(null),
    contact: useRef(null),
    faq: useRef(null),
    footer: useRef(null),
  };

  const [bgColor, setBgColor] = useState('#86cde9');

  const sectionOrder = [
    { key: 'hero', color: '#86cde9' },
    { key: 'contact', color: '#86cde9' },
    { key: 'faq', color: '#02044f' },
    { key: 'footer', color: '#02044f' },
  ];

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const interpolateColor = (c1, c2, factor) => ({
    r: Math.round(c1.r + (c2.r - c1.r) * factor),
    g: Math.round(c1.g + (c2.g - c1.g) * factor),
    b: Math.round(c1.b + (c2.b - c1.b) * factor),
  });

  const rgbToHex = ({ r, g, b }) =>
    `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      for (let i = 0; i < sectionOrder.length - 1; i++) {
        const ref1 = refs[sectionOrder[i].key].current;
        const ref2 = refs[sectionOrder[i + 1].key].current;

        if (!ref1 || !ref2) continue;

        const start = ref1.offsetTop;
        const end = ref2.offsetTop;
        const color1 = hexToRgb(sectionOrder[i].color);
        const color2 = hexToRgb(sectionOrder[i + 1].color);

        if (scrollY >= start && scrollY < end) {
          const progress = (scrollY - start) / (end - start);
          const blendedColor = interpolateColor(color1, color2, progress);
          setBgColor(rgbToHex(blendedColor));
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="overflow-hidden relative">
      {/* Background Layer */}
      <div
        className="fixed inset-0 z-[-1] transition-all duration-700 ease-in-out"
        style={{ backgroundColor: bgColor }}
      />

      <Navbar />
      <div ref={refs.hero}>
        <Hero />
      </div>
      <div ref={refs.contact}>
        <ContactFormSection />
      </div>
      <div ref={refs.faq}>
        <FaqSection />
      </div>
      <div ref={refs.footer}>
        <Footer />
      </div>
    </div>
  );
};

export default ContactPage;
